import { render } from "./ShiftDetailsSidebarItemSkeleton.vue?vue&type=template&id=74980fa0&scoped=true&ts=true"
import script from "./ShiftDetailsSidebarItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./ShiftDetailsSidebarItemSkeleton.vue?vue&type=script&lang=ts"

import "./ShiftDetailsSidebarItemSkeleton.vue?vue&type=style&index=0&id=74980fa0&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74980fa0"]])

export default __exports__